module.exports = __webpack_public_path__ + "img/finagent-details-icon-light.6f7cc88.svg";